import React from "react";
import style from "./AssessmentStep.module.scss";
import OptionList from "../../../secondary/OptionList/OptionList";
import Tooltip from "../../../secondary/Tooltip/tooltip";
import InfoIcon from "../../../../static/images/info.svg";

const AssessmentStep = ({ step, index, isActive, isLoading, onSelect, onEdit }) => {
  const { question, description, options, selected } = step;

  if (!isActive) {
    return (
      <div className={style.step_completed}>
        <button type="button" className={style.step_completed_row} onClick={() => onEdit(index)}>
          <span className={style.step_question}>{question}</span>
          <span className={style.step_answer_group}>
            <span className={style.step_answer}>{selected}</span>
            <span className={style.step_change}>Change</span>
          </span>
        </button>
      </div>
    );
  }

  return (
    <div className={style.step_active}>
      <div className={style.step_text}>
        {description && description !== "None" && (
          <Tooltip placement="right" width="400px" content={description}>
            <img src={InfoIcon} alt="" className={style.chip_icon} />
          </Tooltip>
        )}
        <h4 className={style.step_question_active}>{question}</h4>
      </div>

      {isLoading ? (
        <div className={style.step_shimmer} aria-hidden="true">
          <span className={style.shimmer_row} />
          <span className={style.shimmer_row} />
          <span className={style.shimmer_row} />
        </div>
      ) : (
        <OptionList
          name={`step-${index}`}
          value={selected}
          onChange={(_, optionLabel, apiValue) => onSelect(index, optionLabel, apiValue)}
          options={options}
          disabled={isLoading}
        />
      )}
    </div>
  );
};

export default AssessmentStep;
